import { useMemo } from 'react';

import { ROUTES } from '@/lib/routes';
import { Funnel } from '@/lib/types';
import { UserHub } from '@addmile/backend-client';
import { CellContext } from '@tanstack/react-table';

export const useUsersTable = (users: UserHub[]) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'id',
        header: 'ID',
        cell: ({ row }: CellContext<UserHub, React.ReactNode>) => <span>{row.original.id}</span>,
        size: 350,
      },
      {
        accessorKey: 'email',
        header: 'Email',
        cell: ({ getValue }: CellContext<UserHub, string>) => <span>{getValue()}</span>,
        size: 200,
      },
      {
        accessorKey: 'platform',
        header: 'Platform',
        cell: ({ getValue }: CellContext<UserHub, string>) => <span>{getValue()}</span>,
        size: 100,
      },
      {
        accessorKey: 'funnel',
        header: 'Funnel',
        cell: ({ getValue }: CellContext<UserHub, Funnel>) => <span>{getValue()?.name ?? ''}</span>,
        size: 100,
      },
      {
        id: 'actions',
        header: 'Actions',
        cell: ({ row }: CellContext<UserHub, string>) => (
          <a
            href={`${ROUTES.ADMIN_USER_DATA}?email=${encodeURIComponent(row.original.email)}`}
            className="button cursor-pointer transition duration-200 text-base font-semibold w-[112px] w-[122px] h-[36px] p-[9px_12px] gap-[6px] rounded-[8px_8px_8px_8px] bg-transparent text-black border border-primary-20 hover:border-primary-40"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Details
          </a>
        ),
        size: 100,
      },
    ],
    [],
  );

  return { data: users, columns };
};
